import { useParams } from "react-router-dom";
import { Col, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import Select from "../../../components/form/Select.jsx";
import DebouncedSelect from "../../../components/form/DebouncedSelect.jsx";
import {
  useGetTopicsQuery,
  useLazyGetSubjectsQuery,
  useLazyGetUsersQuery,
} from "../../../redux/service.js";

const { Title, Text } = Typography;

const SearchFields = ({ form, includeTopics = false }) => {
  const { t } = useTranslation();
  const { topic } = useParams();

  const [getSubjects] = useLazyGetSubjectsQuery();
  const [getUsers] = useLazyGetUsersQuery();
  const { data: topicsData, isSuccess: topicsIsSuccess } = useGetTopicsQuery({
    pagination: "off",
  });

  const resetFilters = () =>
    form.reset({
      topicName: topic,
      title: null,
      time: null,
      subjects: null,
      topics: null,
      authors: null,
      ordering: "-published",
    });

  return (
    <div>
      <Row>
        <Col span={18}>
          <Title level={4}>{t("filterBy")}:</Title>
        </Col>
        <Col span={6}>
          <Text
            onClick={resetFilters}
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            {t("reset")}
          </Text>
        </Col>
      </Row>
      {includeTopics && topicsIsSuccess ? (
        <div className="mt-2 mb-3">
          <Title level={5} className="mb-2">
            {t("topic")}
          </Title>
          <Select
            name="topics"
            options={topicsData.map((i) => ({
              value: i.id.toString(),
              label: i.title,
            }))}
            placeholder={t("select")}
            control={form.control}
          />
        </div>
      ) : null}
      <div className="mt-2 mb-3">
        <Title level={5} className="mb-2">
          {t("subjectArea")}
        </Title>
        <DebouncedSelect
          control={form.control}
          trigger={getSubjects}
          filterName="name"
          labelName="name"
          name="subjects"
          placeholder={t("startTypingToSearch")}
          mode="multiple"
        />
      </div>
      <div className="mt-2 mb-3">
        <Title level={5} className="mb-2">
          {t("author")}
        </Title>
        <DebouncedSelect
          control={form.control}
          trigger={getUsers}
          filterName="search"
          labelName="fullName"
          name="authors"
          placeholder={t("startTypingToSearch")}
          mode="multiple"
        />
      </div>
    </div>
  );
};

SearchFields.propTypes = {
  form: PropTypes.object.isRequired,
  includeTopics: PropTypes.bool,
};

export default SearchFields;
